import { render, staticRenderFns } from "./DispatchingCard.vue?vue&type=template&id=5bf2c202&scoped=true"
import script from "./DispatchingCard.vue?vue&type=script&lang=js"
export * from "./DispatchingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf2c202",
  null
  
)

export default component.exports